module.exports = __webpack_public_path__ + "static/media/cherry_tomatoes_blog_img.9d8df09e.webp";